import Staction from '@bluebeam/staction';
import { AppActions } from 'actions';
import AppStoreContext from 'contexts/AppStoreContext';
import * as React from 'react';
import { AppState } from 'records/AppState';

const useAppState = (): Staction<AppState, AppActions>['state'] => {
  const context = React.useContext(AppStoreContext);

  return context.state;
};

export { useAppState };
